export default __webpack_public_path__ + "static/media/logo_autopass_for_business_mobile.3ca77bb7.svg";